import { GreenToRedCandlesLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/GreenToRedCandlesLine';
import { GreenToRedCandlesTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/GreenToRedCandlesTacticPanel';
import { AddGreenToRedCandlesTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddGreenToRedCandlesTacticPanel';
import { GreenToRedCandlesWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/GreenToRedCandlesModule/wrapper/GreenToRedCandlesWrapper';
import { GreenToRedCandlesDocs } from '../../../../components/forms/tradeplans/documentation/GreenToRedDocumentation';
import GreenToRedCandlesModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/GreenToRedCandlesModule';
import { GreenToRedCandlesData } from './greenToRedCandlesData';
import { validateGreenToRedCandles } from './validateGreenToRedCandles';

export const GreenToRedCandles = {
  //data class
  dataStore: GreenToRedCandlesData,

  //string constants
  name: 'GREEN_TO_RED_CANDLES',
  tacticLabel: 'Green to Red Candles',
  addTacticLabel: 'Add Green to Red Candles',
  category: 'Exit',

  // components
  tradePlanFormModule: GreenToRedCandlesModule,
  tacticPanel: GreenToRedCandlesTacticPanel,
  addTacticPanel: AddGreenToRedCandlesTacticPanel,
  wrapper: GreenToRedCandlesWrapper,
  chartSoftOrderComponent: GreenToRedCandlesLine,
  documentation: GreenToRedCandlesDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateGreenToRedCandles,
};
